import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";

export function initTwoFAVerificationModal() {
  setCookieListener();
  toggle2FAModal();
  sendCodeButtonListener();
  verifyCodeButtonListener();
  setTwilloInputs();
}

function setTwilloInputs() {
  var inputNumber = document.getElementById("phone-number");

  if (inputNumber) {
    intlTelInput(inputNumber, {
      initialCountry: "auto",
      separateDialCode: true,
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
    });
  }
}

function setCookieListener() {
  const loginForm = document.getElementById("login-form");
  if (loginForm) {
    loginForm.addEventListener("submit", function (event) {
      const rememberMe = document.getElementById("remember-me-checkbox")
        .checked;
      if (rememberMe) {
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 30);
        document.cookie =
          "rememberMe2FA=true; expires=" +
          expirationDate.toUTCString() +
          "; path=/";
      }
    });
  }
}

function toggle2FAModal() {
  const modal2faButton = document.getElementById("2fa-modal-btn");

  if (modal2faButton) {
    modal2faButton.addEventListener("click", function () {
      $("#2fa-modal").modal("show");
    });
  }
}

function sendCodeButtonListener() {
  const sendCodeButton = document.getElementById("send-code");

  if (sendCodeButton) {
    sendCodeButton.addEventListener("click", function () {
      handleSendCodeClick();
    });
  }
}

function handleSendCodeClick() {
  const phoneNumberElement = document.getElementById("saved-phone-number");
  let phoneNumber = null;
  if (phoneNumberElement) {
    phoneNumber = phoneNumberElement.value;
  }

  if (phoneNumber && phoneNumber.startsWith("+")) {
    sendVerificationCode(phoneNumber);
  } else {
    const countryCode = document.querySelector(".iti__selected-dial-code");
    const phoneNumberInput = document.getElementById("phone-number");
    const countryCodeValue = countryCode
      ? countryCode.innerText.trim().replace(/^\+/, "")
      : "";
    const phoneNumberValue = phoneNumberInput
      ? phoneNumberInput.value.trim()
      : "";
    const countryCodeRegex = /^\d+$/;
    const phoneNumberRegex = /^\d+$/;

    if (countryCodeValue === "" || phoneNumberValue === "") {
      alert("Please fill in both the country code and the phone number.");
    } else if (!countryCodeRegex.test(countryCodeValue)) {
      alert("Please enter a valid country code.");
    } else if (!phoneNumberRegex.test(phoneNumberValue)) {
      alert("Please enter a valid phone number.");
    } else {
      const fullPhoneNumber = "+" + countryCodeValue + phoneNumberValue;
      sendVerificationCode(fullPhoneNumber);
    }
  }
}

function sendVerificationCode(fullPhoneNumber) {
  $.ajax({
    url: "/api/v1/accounts/send_mobile_verification",
    type: "POST",
    data: { phone_number: fullPhoneNumber },
    success: function (response) {
      if (response.success) {
        document.getElementById("phone-step").style.display = "none";
        document.getElementById("code-step").style.display = "flex";
      } else {
        alert("Failed to send verification code: " + response.error);
      }
    },
    error: function (xhr, status, error) {
      alert("An error occurred: " + error);
    },
  });
}

function verifyCodeButtonListener() {
  const verifyCodeButton = document.getElementById("verify-code");

  if (verifyCodeButton) {
    verifyCodeButton.addEventListener("click", function () {
      handleVerifyCodeClick(verifyCodeButton.dataset.modaltype);
    });
  }
}

function handleVerifyCodeClick(modalType) {
  const verificationCodeInput = document.getElementById("verification-code");
  const verificationCode = verificationCodeInput
    ? verificationCodeInput.value
    : "";

  $.ajax({
    url: "/api/v1/accounts/verify_mobile_code",
    type: "POST",
    data: { verification_code: verificationCode, user_action: modalType },
    success: function (response) {
      if (response.success) {
        document.getElementById("code-step").style.display = "none";
        document.getElementById("success-message").style.display = "flex";

        setTimeout(function () {
          location.reload();
        }, 3000);
      } else {
        alert("Failed to verify code: " + response.error);
      }
    },
    error: function (xhr, status, error) {
      alert("An error occurred: " + error);
    },
  });
}
